import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Vaata kõiki tootepilte

  <span style="color:#85c1dc;">**FI:**</span>
  Katso kaikkia tuotekuvia

  <span style="color:#85c1dc;">**RU:**</span>
  Посмотреть все изображения товара
*/
/* @__NO_SIDE_EFFECTS__ */
const m620 = msg(
  mf`Vaata kõiki tootepilte`,
  mf`Katso kaikkia tuotekuvia`,
  mf`Посмотреть все изображения товара`,
)

export { m620 as 'w.module.image_viewer.show_all_images' }